<div class="container">
  <div>
    <img src="{{ data.imgLink }}" alt="shoe image" />
    <button mat-button-raised (click)="onNoClick()">Close</button>
  </div>
</div>
